import logo from '../../images/LogoFooter.svg';
import logo_fond from '../../images/logo_w.svg';
const Footer = () => {
    return(
        <>
            <section className="bg-[#304DB6] w-full">
            <div className="max-w-[1920px]  w-full flex justify-between items-center
            sm:px-10 sm:py-10
            md:px-12 md:py-12
            lg:px-[120px] lg:py-16
            xl:px-[120px] xl:py-16">
                <img src={logo} alt="logo" className='sm:w-[200px] md:w-[240px] pr-[20px]'/>
                <div className='flex flex-col gap-2 text-white font-light items-end
                sm:text-base sm:items-start
                md:text-lg
                lg:text-[20px]
                xl:text-6 xl:flex xl:flex-col'>
                    <p className='font-bold '>ООО "Неясыти АЭРО"</p>
                    <a href="tel:+79009000000" >+7 900 900 00 00</a>
                    <a href="mailto:myemail@email.ru">myemail@email.ru</a>
                    <p className='pb-[40px]'>Ленинский проспект, 2А, Москва, 119049</p>
                    <p className='max-w-[90%] text-right sm:text-left'>Проект создается при помощи фонда содействия инновациям</p>
                    <img src={logo_fond} className='sm:w-[100px] md:w-[120px] pr-[20px]'/>
                </div>
            </div>
            </section>
        </>
    )
}
export default Footer;